import { omit } from 'lodash';
import { combineReducers } from 'redux';
import { createReducer, Type } from 'store/utils';
import { RESET_SHARED_DATA, SET_SHARED_DATA } from './constants';

export const initialState = {
  sharedData: {},
};

const sharedDataTypes: Type[] = [
  {
    type: SET_SHARED_DATA,
    mapper: (state, { id, data }) => ({
      ...state,
      [id]: data,
    }),
  },
  {
    type: RESET_SHARED_DATA,
    mapper: (state, { id }) => omit(state, id),
  },
];

export default combineReducers({
  sharedData: createReducer({
    types: sharedDataTypes,
    initialState: initialState.sharedData,
  }),
});
